<template>
  <a-modal
    v-model="visible.writeOffModal"
    width="75%"
    title="核销"
    :maskClosable="false"
    :destroyOnClose="true"
    :centered="true"
    :confirmLoading="visible.confirmLoading"
  >
    <template slot="footer">
      <span class="total-amount"
        >未核销金额总计：<span>&yen;{{ unWriteOffAmount }}</span></span
      >
      <a-button @click="visible.writeOffModal = false">取消</a-button>
      <a-button
        type="primary"
        @click="onSubmit"
        :loading="visible.confirmLoading"
        >确定</a-button
      >
    </template>
    <div>
      <data-grid
        ref="dataGrid"
        :columns="columns"
        v-model="data"
        :params="params"
        bordered
        :props="{
          scroll: {
            y: 300,
            x: 800
          }
        }"
      >
      </data-grid>

      <div class="title">
        <strong>付款方式</strong>
        <a-button
          style="margin-left:10px;"
          type="primary"
          size="small"
          icon="plus"
          @click="addRow()"
          >增加收款</a-button
        >
        <span style="float:right; "
          >总计：<em style="font-size:16px;color:#f00;font-style:normal"
            >￥{{ totalAmount }}</em
          ></span
        >
      </div>
      <div>
        <div class="cnt">
          <div>
            <table class="payTable">
              <thead>
                <tr style="background-color: #ffffeb;text-align: center;">
                  <td>付款方式</td>
                  <td>金额</td>
                  <td>单据号</td>
                  <td>备注</td>
                  <td></td>
                </tr>
              </thead>
              <tbody ref="payTable">
                <tr
                  style="background-color: white;"
                  v-for="(item, index) in writeOffData.PayWays"
                  :key="index"
                >
                  <td>
                    <a-select
                      style="width: 100%"
                      v-model="item.AccountItemId"
                      @change="onChangePayWay(index)"
                    >
                      <a-select-option
                        v-for="(item, index) in select.payway"
                        :key="index"
                        :value="item.Id"
                        :title="item.Name"
                        >{{ item.Name }}</a-select-option
                      >
                    </a-select>
                  </td>
                  <td>
                    <a-input-number
                      :min="0"
                      :max="Number(writeOffAmount)"
                      style="width: 100%"
                      @change="onChangeMoney"
                      v-model="item.WriteOffAmount"
                    />
                  </td>
                  <td>
                    <a-input v-model="item.No" />
                  </td>
                  <td>
                    <a-input v-model="item.Remark" />
                  </td>
                  <td>
                    <a-icon
                      class="del-icon"
                      type="minus-circle"
                      title="删除"
                      @click="delRow(index)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
// import { getSelectData } from "@/utils/common";
import { BankOrScanPayModal } from "@/views/orderManage/orderComponent/funtion.js";
import calc from "@/utils/calc";
export default {
  name: "writeOff",
  props: {
    guestId: {
      type: String,
      default: ""
    },
    orderNo: {
      type: [String, Number],
      default: ""
    }
  },
  components: {
    DataGrid
  },
  data() {
    return {
      params: {},
      data: [],
      columns: [
        {
          title: "单号",
          dataIndex: "OrderNo",
          width: "12%"
        },
        {
          title: "挂账日期",
          dataIndex: "AccountDate",
          width: "12%"
        },
        {
          title: "状态",
          dataIndex: "Status",
          width: "10%",
          customRender: text => {
            if (text) {
              return <a-badge status="success" text="已核销" />;
            } else {
              return <a-badge status="error" text="未核销" />;
            }
          }
        },
        {
          title: "姓名",
          width: "12%",
          dataIndex: "Contact"
        },
        {
          title: "金额",
          dataIndex: "Amount",
          align: "right",
          width: "10%"
        },
        {
          title: "未核金额",
          dataIndex: "UnWriteOffAmount",
          align: "right",
          width: "10%"
        },
        {
          title: "备注",
          dataIndex: "Remark"
        }
      ],
      select: {}, //下拉数据
      writeOffData: {
        OrderIds: [],
        PayWays: []
      },
      visible: {
        writeOffModal: false,
        confirmLoading: false
      },
      totalAmount: 0, //计算付款方式总金额
      writeOffAmount: 0, //核销总额
      defaultItem: {},
      unWriteOffAmount: 0
    };
  },
  created() {
    this.getDefaultItem();
    this.$post("Account_GetReceivable").then(res => {
      this.select.payway = res.Data.filter(
        el =>
          !(
            (el.Attributes & 16777216) > 0 ||
            (el.Attributes & 134217728) > 0 ||
            (el.Attributes & 268435456) > 0
          )
      );
    });
  },
  methods: {
    //获取系统参数值
    getDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    show(rows) {
      this.visible.writeOffModal = true;
      this.data = rows;
      let total = 0;
      rows.forEach(el => {
        // total = accAdd(el.UnWriteOffAmount, total);
        total = calc(total)
          .add(el.UnWriteOffAmount)
          .number(2);
      });
      this.unWriteOffAmount = total;
      this.init();
    },
    init() {
      this.writeOffData.OrderIds = [];
      this.writeOffData.PayWays = [];
      this.writeOffAmount = 0;
      this.totalAmount = 0;
      this.addRow();
      this.writeOffData.PayWays[0].WriteOffAmount = this.unWriteOffAmount;
      this.$nextTick(() => {
        this.onChangeMoney();
      });

      for (let i = 0; i < this.data.length; i++) {
        this.writeOffData.OrderIds.push(this.data[i].Id);
        // this.writeOffAmount = accAdd(
        //   this.writeOffAmount,
        //   this.data[i].UnWriteOffAmount
        // );
        this.writeOffAmount = calc(this.writeOffAmount)
          .add(this.data[i].UnWriteOffAmount)
          .number(2);
      }
    },
    onChangePayWay(index) {
      for (let i = 0; i < this.select.payway.length; i++) {
        const item = this.select.payway[i];
        if (item.Id == this.writeOffData.PayWays[index].AccountItemId) {
          this.writeOffData.PayWays[index].AccountItemName = item.Name;
        }
      }
      let paywayItem = this.select.payway.find(
        p => p.Id == this.writeOffData.PayWays[index].AccountItemId
      );
      if (
        ((paywayItem.Attributes & 131072) > 0 ||
          (paywayItem.Attributes & 262144) > 0) &&
        this.defaultItem.HuiyiPos == "1"
      ) {
        let title = "",
          payType = "";
        if ((paywayItem.Attributes & 131072) > 0) {
          title = "银行卡消费";
          payType = 1;
        } else if ((paywayItem.Attributes & 262144) > 0) {
          title = "扫码消费";
          payType = 2;
        }
        // else {
        //   title = "预授权";
        //   payType = 3;
        // }
        this.writeOffData.PayWays[index].Money = this.writeOffData.PayWays[
          index
        ].WriteOffAmount;
        BankOrScanPayModal({
          title: title,
          payType: payType,
          isLimit: true,
          tipInfo:
            "注：最大核销金额：" +
            this.writeOffAmount +
            "；支付成功后该笔款项将自动核销。",
          limitAmont: this.writeOffAmount,
          option: this.writeOffData.PayWays[index],
          PaySign: 3,
          defaultItem: this.defaultItem,
          orderId: this.guestId,
          orderNo: this.orderNo,
          update: data => {
            this.callBack(data, index, paywayItem);
          }
        });
      } else if ((paywayItem.Attributes & 2097152) > 0) {
        const payConfig = JSON.parse(this.defaultItem.AllInPayConfig);
        if (payConfig.status == 1) {
          const tit =
            (paywayItem.Attributes & 2097152) > 0
              ? "通联扫码"
              : "通联扫码预授权";
          const paiApi =
            (paywayItem.Attributes & 2097152) > 0
              ? "/api/AllInPayQrPay/Pay"
              : "/api/AllInPayPreQrPay/Pay";
          this.writeOffData.PayWays[index].Money = this.writeOffData.PayWays[
            index
          ].WriteOffAmount;
          const payType = (paywayItem.Attributes & 2097152) > 0 ? 1 : 3;
          const arr = this.data.map(v => {
            return v.Contact;
          });
          this.writeOffData.PayWays[index].Title = arr.join(",");
          BankOrScanPayModal({
            title: tit,
            payType: payType,
            hasAuthCode: true,
            payApi: paiApi,
            isLimit: true,
            tipInfo:
              "注：最大核销金额：" +
              this.writeOffAmount +
              "；支付成功后该笔款项将自动核销。",
            limitAmont: this.writeOffAmount,
            option: this.writeOffData.PayWays[index],
            PaySign: 3,
            defaultItem: this.defaultItem,
            orderId: this.guestId,
            orderNo: this.orderNo,
            update: data => {
              this.callBack(data, index, paywayItem);
            }
          });
        }
      }
    },
    callBack(data, index, paywayItem) {
      if (data) {
        const json = {
          OrderIds: this.writeOffData.OrderIds,
          PayWays: [
            {
              AccountItemId: paywayItem.Id,
              AccountItemName: paywayItem.Name,
              WriteOffAmount: data.payMoney,
              No: data.payBillNo,
              Remark: data.payRemark
            }
          ]
        };
        this.$post("RecVa_WriteOff", json)
          .then(() => {
            this.visible.writeOffModal = false;
            this.$message.success("核销成功");
            this.$emit("reloadDetail");
          })
          .catch(() => {
            this.visible.confirmLoading = false;
            this.writeOffData.PayWays[index].AccountItemId = "";
          });
      } else {
        this.writeOffData.PayWays[index].AccountItemId = "";
      }
    },
    onChangeMoney() {
      this.totalAmount = 0; //重新计算
      this.writeOffData.PayWays.forEach((item, index) => {
        if (!item.WriteOffAmount) item.WriteOffAmount = 0;
        let headerTd = this.$refs.payTable.querySelectorAll("tr")[index]
          .children[1];
        this.$common.removeClass(headerTd, "shake");
        if (Number(item.WriteOffAmount) > Number(this.writeOffAmount)) {
          this.$common.addClass(headerTd, "shake");
          this.$message.error("大于总核销金额,请重新输入");
          // item.WriteOffAmount = 0;
        }
        // this.totalAmount = accAdd(this.totalAmount, item.WriteOffAmount);
        this.totalAmount = calc(this.totalAmount)
          .add(item.WriteOffAmount)
          .number(2);
      });
    },
    delRow(index) {
      this.writeOffData.PayWays.splice(index, 1);
      this.onChangeMoney();
    },
    addRow() {
      this.writeOffData.PayWays.push({
        AccountItemId: null,
        AccountItemName: "",
        WriteOffAmount: 0,
        No: "",
        Remark: ""
      });
    },
    onSubmitBefore() {
      let isChecked = true; //数据验证默认通过
      if (Number(this.totalAmount) < 0) {
        this.$message.error("总计金额不能小于0！");
        return false;
      }
      if (Number(this.totalAmount) > Number(this.writeOffAmount)) {
        this.$message.error("付款金额不能大于待核销金额");
        return false;
      }
      for (let i = 0; i < this.writeOffData.PayWays.length; i++) {
        const item = this.writeOffData.PayWays[i];
        if (Number(item.WriteOffAmount) > 0 && !item.AccountItemId) {
          this.$message.error("金额不为0时,付款方式必填！");
          isChecked = false;
          break;
        }
      }
      return isChecked;
    },
    onSubmit() {
      let json = this.onSubmitBefore();
      if (json === false) return;
      this.visible.confirmLoading = true;
      this.$post("RecVa_WriteOff", this.writeOffData)
        .then(() => {
          this.visible.writeOffModal = false;
          this.visible.confirmLoading = false;
          this.$message.success("核销成功");
          this.$emit("reloadDetail");
        })
        .catch(() => {
          this.visible.confirmLoading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  font-size: initial;
  margin-top: 5px;
}
.cnt {
  border: 1px solid #eee;
  max-height: 250px;
  overflow: auto;
  border-top: 0;
}
.payTable {
  width: 100%;
  margin-bottom: 5px;
  tr {
    td {
      padding: 2px 1px;
      width: 10%;
    }
  }
}
/deep/
  .ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
/deep/ .ant-table-bordered .ant-table-tbody > tr > td {
  padding: 2px 3px 0 3px !important;
}
@keyframes shake {
  0% {
    transform: scale(1.02);
    border-color: #f00;
  }
  25% {
    transform: scale(1.05);
    border-color: #f00;
  }
  50% {
    transform: scale(1);
    border-color: #f00;
  }
  75% {
    transform: scale(1.05);
    border-color: #f00;
  }
  100% {
    transform: scale(1);
    border-color: #d9d9d9;
  }
}
.shake /deep/ .ant-input-number {
  -webkit-animation: shake 1s;
  animation: shake 1s;
}
.total-amount {
  margin-right: 100px;
  color: #333;
  & > span {
    font-size: 18px;
    color: #f00;
  }
}
.del-icon {
  color: #f00;
  font-size: 16px;
  margin-top: 5px;
  margin-left: 5px;
  cursor: pointer;
}
</style>
